import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ExtructSimilarHistory } from '@/features/admin/extruct-similar-history'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(50),
  filter: z.string().optional().catch(''),
  searchId: z.string().optional().catch(undefined),
})

export const Route = createFileRoute(
  '/_authenticated/admin/extruct-similar-history'
)({
  validateSearch: searchSchema,
  component: ExtructSimilarHistory,
})
